import React from "react";

/**
 * The page control every paginated list carries (affiliate tables, review lists).
 *
 * PRESENTATIONAL, like `LoadFailure`: the caller resolves the three strings, so this file
 * imports no dictionary and can be rendered for real in any suite. `next` is disabled from
 * `page * pageSize >= total` — the server states the page size it actually applied, so the
 * control cannot offer a page the clamp would not have served.
 *
 * `tone` picks the plane's palette: the practitioner console is cream/ink (`eh-*`), the
 * operator console is slate, the marketplace is white-on-midnight. One component, because
 * the BEHAVIOUR is identical and it is the behaviour that is easy to get subtly wrong.
 */
const TONES = {
  admin: { border: "border-eh-border-soft", text: "text-eh-muted" },
  slate: { border: "border-slate-200", text: "text-slate-400" },
  dark: { border: "border-white/10", text: "text-white/50" },
};

export default function Pager({
  page, pageSize, total, shown, onPage, infoText, prevLabel, nextLabel, testId, tone = "admin",
}) {
  const firstRow = shown ? (page - 1) * pageSize + 1 : 0;
  const skin = TONES[tone] || TONES.admin;
  return (
    <div className={`flex items-center justify-between gap-3 px-4 py-3 border-t ${skin.border}`}>
      <span className={`text-xs tabular-nums ${skin.text}`} data-testid={`${testId}-info`}>
        {infoText({ from: firstRow, to: firstRow ? firstRow + shown - 1 : 0, total })}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          className={`text-xs px-3 py-1.5 rounded-lg border disabled:opacity-40 ${skin.border}`}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          data-testid={`${testId}-prev`}
        >
          {prevLabel}
        </button>
        <button
          type="button"
          className={`text-xs px-3 py-1.5 rounded-lg border disabled:opacity-40 ${skin.border}`}
          disabled={page * pageSize >= total}
          onClick={() => onPage(page + 1)}
          data-testid={`${testId}-next`}
        >
          {nextLabel}
        </button>
      </div>
    </div>
  );
}
